import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import type { Town, TownListQuery } from '@shared/types/town';
import type { PaginatedResponse } from '@shared/types/api';

async function fetchTowns(params: TownListQuery): Promise<PaginatedResponse<Town>> {
    const query: Record<string, string> = {};

    if (params.page) query.page = String(params.page);
    if (params.limit) query.limit = String(params.limit);
    if (params.search) query.search = params.search;
    if (params.category) query.category = params.category;
    if (params.orderer) query.orderer = params.orderer;
    if (params.contractType) query.contractType = params.contractType;
    if (params.settingStaff) query.settingStaff = params.settingStaff;
    if (params.status) query.status = params.status;
    if (params.expiring) query.expiring = 'true';
    if ((params as any).recent) query.recent = 'true';
    if (params.sortBy) query.sortBy = params.sortBy;
    if (params.sortOrder) query.sortOrder = params.sortOrder;
    if ((params as any).onepass) query.onepass = (params as any).onepass;
    if ((params as any).emergencyBell) query.emergencyBell = (params as any).emergencyBell;

    const { data } = await api.get<PaginatedResponse<Town>>('/towns', { params: query });
    return data;
}

export function useTowns(params: TownListQuery) {
    return useQuery({
        queryKey: ['towns', params],
        queryFn: () => fetchTowns(params),
    });
}
